import { contract } from '@/configs/endpoints'
import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import { formData } from '@/configs/dates'
const store = 'contract'

export default {
  state: () => ({
    contracts: [],
    cooperationAgreements: [],
    cooperationAgreement: {},
    contractCompany: null
  }),
  actions: {
    // Заяви на співпрацю
    async getContracts (context) {
      const response = await api.get(contract.contracts)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'contracts', data: response.data.results })
      }
    },
    async createContract (context, data) {
      const response = await api.post(contract.contracts, { body: data })
      const res = await requestValidation(response)
      if (res) {
        context.commit('ADD_DATA', { store, state: 'contracts', data: response.data })
        context.commit('SET_DATA', { store, state: 'contractCompany', data: response.data })
      }
      return res
    },
    contractMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return await api.post(contract.contractsMedia(data.id), { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    async updateContract (context, data) {
      const response = await api.patch(contract.contract(data.id), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('UPDATE_DATA', { store, state: 'contracts', data: response.data })
      }
      return await requestValidation(response)
    },

    // Угоди про співпрацю
    async getCooperationAgreements (context) {
      const response = await api.get(contract.cooperationAgreements)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'cooperationAgreements', data: response.data })
      }
    },
    async getCooperationAgreement (context, id) {
      const response = await api.get(contract.cooperationAgreement(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'cooperationAgreement', data: response.data })
      }
      return await requestValidation(response)
    },
  }

}
